import { render, staticRenderFns } from "./seriesSoporteData.vue?vue&type=template&id=f2143260&scoped=true&"
import script from "./seriesSoporteData.vue?vue&type=script&lang=js&"
export * from "./seriesSoporteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2143260",
  null
  
)

export default component.exports